import MessageBubble from './MessageBubble';

const StreamingBubble = ({ text, colors }) => {
    const fakeMessage = {
        id: 'streaming',
        type: 'text',
        text,
        user: 'bot',
        timestamp: new Date().toISOString(),
    };
    return <MessageBubble message={fakeMessage} colors={colors} />;
};

export default StreamingBubble;
